import { useState } from "react";
import axios from "axios";
import "./auth.css";
import API_BASE_URL from "../api";

function Register({ onSwitch }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [banner, setBanner] = useState(null);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!email.trim()) e.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(email)) e.email = "Invalid email address";
    if (!password) e.password = "Password is required";
    return e;
  };

  const handleRegister = async () => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    setErrors({});
    setLoading(true);
    setBanner(null);

    try {
      await axios.post(`${API_BASE_URL}/auth/register`, { email, password });
      setBanner({ type: "ok", msg: "Account created successfully. You can now login." });
    } catch (err) {
      setBanner({ type: "fail", msg: err.response?.data?.msg || "Registration failed." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="glow-orb glow-orb-1" />
      <div className="glow-orb glow-orb-2" />

      <div className="auth-wrap">
        <div className="term-bar">
          <div className="dots">
            <div className="dot dot-r" />
            <div className="dot dot-y" />
            <div className="dot dot-g" />
          </div>
          <div className="term-path">envsync - <span>auth/register</span></div>
        </div>

        <div className="card">
          <div className="brand">
            <div className="brand-title">env<span className="hl">sync</span></div>
            <div className="brand-sub">Create your account</div>
          </div>

          <div className="section-label">sign up</div>

          {banner && (
            <div className={`banner ${banner.type}`}>
              {banner.type === "ok" ? "OK" : "ERR"} {banner.msg}
            </div>
          )}

          <div className="field">
            <div className="field-label"><span className="prompt">$</span> email</div>
            <div className="input-box">
              <input
                className={`input${errors.email ? " err" : ""}`}
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((prev) => ({ ...prev, email: null }));
                }}
              />
            </div>
            {errors.email && <div className="field-err">-> {errors.email}</div>}
          </div>

          <div className="field">
            <div className="field-label"><span className="prompt">$</span> password</div>
            <div className="input-box">
              <input
                className={`input${errors.password ? " err" : ""}`}
                type={showPw ? "text" : "password"}
                placeholder="************"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors((prev) => ({ ...prev, password: null }));
                }}
                style={{ paddingRight: "60px" }}
              />
              <button className="pw-btn" onClick={() => setShowPw(!showPw)}>
                {showPw ? "[hide]" : "[show]"}
              </button>
            </div>
            {errors.password && <div className="field-err">-> {errors.password}</div>}
          </div>

          <div className="field">
            <div className="field-label"><span className="prompt">$</span> role</div>
            <div className="input-box" style={{ cursor: "default" }}>
              <input
                className="input"
                type="text"
                value="owner"
                readOnly
                style={{ color: "#00ff88", cursor: "default" }}
              />
            </div>
            <div className="field-err" style={{ color: "#4a5568" }}>-> you will own a default project and can share it with others</div>
          </div>

          <button className="submit" onClick={handleRegister} disabled={loading}>
            {loading ? <><div className="spinner" /> creating account...</> : "-> register"}
          </button>

          <div className="footer-note">
            already have an account?{" "}
            <span className="accent" onClick={onSwitch}>login here</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
